import { useEffect, useRef } from "react";

/*
 * Сканер штрихкодов в режиме клавиатуры: символы идут быстрее 50 мс друг за
 * другом и кончаются Enter. Ловим их вне полей ввода; в поле код попадает
 * сам, его отправляет форма поля. Человек так быстро не печатает, поэтому
 * обычные горячие клавиши не страдают.
 */
const MAX_GAP_MS = 50;
const MIN_LENGTH = 3;

function isEditable(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return target.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName);
}

export function useScanner(onScan: (code: string) => void): void {
  const buffer = useRef("");
  const last = useRef(0);
  const handler = useRef(onScan);

  useEffect(() => {
    handler.current = onScan;
  }, [onScan]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (isEditable(e.target) || e.ctrlKey || e.metaKey || e.altKey) return;
      const now = performance.now();
      if (now - last.current > MAX_GAP_MS) buffer.current = "";
      last.current = now;
      if (e.key === "Enter") {
        if (buffer.current.length >= MIN_LENGTH) {
          e.preventDefault();
          handler.current(buffer.current);
        }
        buffer.current = "";
      } else if (e.key.length === 1) {
        buffer.current += e.key;
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
}
